import React from "react";

import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./Footer.module.scss";

const messages = defineMessages({
  cancel: {
    id: "email.emailScheduleSendPopover.cancel",
    defaultMessage: "Cancel",
    description: "Schedule send popover cancel button",
  },
  reschedule: {
    id: "email.emailScheduleSendPopover.reschedule",
    defaultMessage: "Reschedule",
    description: "Schedule send popover reschedule button",
  },
  schedule: {
    id: "email.emailScheduleSendPopover.schedule",
    defaultMessage: "Schedule",
    description: "Schedule send popover schedule button",
  },
  scheduledFor: {
    id: "email.emailScheduleSendPopover.scheduledFor",
    defaultMessage: "Scheduled for {dateTime}",
    description: "Schedule send popover footer summary",
  },
});

interface FooterProps {
  disabled: boolean;
  isEditing?: boolean;
  onCancel: () => void;
  onSchedule: () => void;
  summary?: string;
}

const Footer = ({ disabled, isEditing, onCancel, onSchedule, summary }: FooterProps) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      {summary && (
        <span className={styles.summary}>
          {intl.formatMessage(messages.scheduledFor, { dateTime: <strong>{summary}</strong> })}
        </span>
      )}
      <div className={styles.actions}>
        <Button onClick={onCancel}>{intl.formatMessage(messages.cancel)}</Button>
        <Button disabled={disabled} onClick={onSchedule} type="primary">
          {intl.formatMessage(isEditing ? messages.reschedule : messages.schedule)}
        </Button>
      </div>
    </div>
  );
};

export default Footer;
